import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FileUploadManagerService } from '../services/fu-manager.service';
import { OverlayService } from '../../../../../../services/overlay.service';
import { ComponentService, CreatorFrontApi } from '../../../../../../services/component.service';
import { NewApiResponse } from '../../../../../../services/new-api-http.service';

@Component({
	selector: 'fu-manager',
	templateUrl: './fu-manager.component.html',
	styleUrls: ['./fu-manager.component.scss']
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class FileUploadManager implements OnInit {
	@Input() allowedDimensions;
	@Input() fileType;
	@Output() output = new EventEmitter();

	viewMode = 'list';
	isPopup;
	total;
	start;
	currentPage;
	type;
	order;
	fileList: FileObject[] = [];
	openSideBar = false;
	selectedFile: FileObject = {
		name: '',
		last_modified: '',
		path: '',
		type: '',
		size: 0,
		fileType: ''
	};
	filterBy = 'images';
	maxPaginationItems = 10;
	apiSubscription;
	uploading = false;
	listHeight = window.innerHeight * 0.63;
	fileToEdit;
	isModalShown = false;
	loaded = false;
	importUrl;

	constructor(
		private sanitation: DomSanitizer,
		private route: ActivatedRoute,
		private router: Router,
		private overlay: OverlayService,
		private files: FileUploadManagerService,
		private cd: ChangeDetectorRef,
		private componentService: ComponentService
	) {}

	ngOnInit() {
		this.isPopup = !!this.fileType;

		this.viewMode = this.route.snapshot.params['view'] ? this.route.snapshot.params['view'] : 'list';
		this.start = this.route.snapshot.params['start'] ? this.route.snapshot.params['start'] : 0;
		this.currentPage = +this.start + 1;
		if (this.route.snapshot.params['type']) {
			this.type = this.route.snapshot.params['type'];
		} else if (this.fileType) {
			this.type = this.fileType;
		} else {
			this.type = '';
		}
		this.order = this.route.snapshot.params['order'] ? this.route.snapshot.params['order'] : 'date';

		this.getFileList(this.start, this.type, this.order);
	}

	getFileList(start, type, order) {
		this.overlay.updateOverlay(true, 'Generating File List...');
		if (this.apiSubscription && this.apiSubscription.unsubscribe) {
			this.apiSubscription.unsubscribe();
		}
		const self = this;
		this.files.getFileList(start, type, order).subscribe((response: NewApiResponse) => {
			this.overlay.updateOverlay(false);
			if (response && response.status) {
				this.total = response.data.total;
				if (typeof response.data.files !== 'undefined') {
					this.fileList = Object.keys(response.data.files).map(function (key) {
						const instance = response.data.files[key];
						const oldPath = response.data.files[key].path;
						const link = self.sanitation.bypassSecurityTrustUrl(response.data.files[key].path);
						const safePath = self.sanitation.bypassSecurityTrustStyle('url(' + response.data.files[key].path + ')');
						instance.path = safePath;
						instance.oldPath = oldPath;
						instance.link = link;

						return instance;
					});
				} else {
					this.fileList = [];
				}
			}
			this.cd.markForCheck();
			this.loaded = true;
		});
	}

	pageChanged(event: any): void {
		window.scrollTo(0, 0);
		this.start = !isNaN(parseFloat(event)) && isFinite(event) ? event : event.page - 1;
		this.currentPage = +this.start + 1;
		const urlParams = ['file-manager', this.viewMode, this.start];
		if (this.order) {
			urlParams.push(this.order);
		}
		if (this.type) {
			urlParams.push(this.type);
		}
		if (!this.fileType) {
			this.router.navigate(urlParams).then(() => {
				this.getFileList(this.start, this.type, this.order);
			});
		} else {
			this.getFileList(this.start, this.type, this.order);
		}
	}

	uploadFile(event) {
		const fileList: FileList = event.target.files;
		if (fileList.length === 0) {
			return false;
		}

		this.uploading = true;
		const file: File = fileList[0];
		this.overlay.updateOverlay(true, 'Uploading file...');
		this.files.uploadFile(file).subscribe((res) => {
			this.overlay.updateOverlay(false);
			if (res['status']) {
				this.uploading = false;
				this.pageChanged(0);
			} else {
				this.uploading = false;
				this.overlay.updateOverlay(true, res['data'], 'alert');
			}
		});
	}

	importFile(importUrl) {
		this.uploading = true;
		if (this.apiSubscription) {
			this.apiSubscription.unsubscribe();
		}

		this.files.importFile(importUrl).subscribe((response: any) => {
			if (response.status) {
				this.pageChanged(0);
			} else {
				this.overlay.updateOverlay(true, response.data, 'alert');
			}
			this.uploading = false;
		});
	}

	deleteFile(fileName) {
		this.uploading = true;
		if (this.apiSubscription && this.apiSubscription.unsubscribe) {
			this.apiSubscription.unsubscribe();
		}
		this.apiSubscription = this.files.deleteFile(fileName).subscribe((response: any) => {
			if (response.status) {
				this.pageChanged(0);
			}
			this.uploading = false;
		});
	}

	handleOutput(event) {
		const self = this;
		switch (event.method) {
			case 'delete': {
				this.deleteFile(event.fileName);
				break;
			}

			case 'selected': {
				//     console.log('FILE MANAGER URL (SELECTED): ', event.fileName);
				this.output.emit({ method: 'selected', url: event.fileName });
				break;
			}

			case 'edit': {
				this.fileToEdit = event.file;
				this.isModalShown = true;
				break;
			}

			case 'cancel': {
				this.isModalShown = false;
				break;
			}

			case 'saveClose': {
				this.files.uploadFile(event.blob).subscribe(
					(res) => {
						if (res && res['status']) {
							this.isModalShown = false;
							this.pageChanged(0);
						} else {
							this.overlay.updateOverlay(true, res['data'], 'alert');
						}
					},
					(error) => this.overlay.updateOverlay(true, error, 'alert')
				);
				break;
			}

			case 'saveSelect': {
				this.files.uploadFile(event.blob).subscribe((res) => {
					if (res && res['status']) {
						self.isModalShown = false;
						//                console.log('FILE MANAGER URL: ', res['url']);
						self.output.emit({ method: 'selected', url: res['url'] });
					} else {
						self.overlay.updateOverlay(true, res['data'], 'alert');
					}
				});
				break;
			}

			default: {
				break;
			}
		}
	}
}

export interface FileObject {
	name: string;
	last_modified: string;
	path: string;
	type: string;
	size: number;
	fileType: string;
}
